import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Utils } from "../misc/Utils";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export class HomePageHandler extends PageHandler {
	constructor(id) {
		super(id);
	}

	showError(text) {
		jQuery('.form-status').text(text);
		jQuery('.form-status').addClass('error')
	}

	hideError() {
		jQuery('.form-status').text('');
		jQuery('.form-status').removeClass('error')
	}

	ajax() {

	}

	events() {
		
	}

	transitions() {
		
	}

	parseEPWFileContent(content, callback) {
		var _this = this;
		var xhr = new XMLHttpRequest();
		gsap.set('.loader', {display: 'block'})
		xhr.open('POST', bipv_script_data.ajax_url, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		
		xhr.onload = function() {
			if (xhr.status === 200) {
				var response = JSON.parse(xhr.responseText);
				if (typeof callback === "function")
					callback(response);
			} 
			else {
				_this.showError('An error occurred while processing the file.')
			}
			gsap.set('.loader', {display: 'none'})
		};
		
		xhr.send('action=epw_check_request&content=' + encodeURIComponent(content) + '&_ajax_nonce_epw_check=' + bipv_script_data.nonce_epw_check);
	}

	checkEPWFileContent(content, callback) {
		var xhr = new XMLHttpRequest();
		var _this = this;
		gsap.set('.loader', {display: 'block'})
		xhr.open('POST', bipv_script_data.ajax_url, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		
		xhr.onload = function() {
			if (xhr.status === 200) {
				var response = JSON.parse(xhr.responseText);
				if (typeof callback === "function")
					callback(response);
			} 
			else {
				_this.showError('An error occurred while processing the file.')
			}
			gsap.set('.loader', {display: 'none'})
		};
		
		xhr.send('action=check_epw_file_content&content=' + encodeURIComponent(content) + '&_ajax_nonce=' + bipv_script_data.nonce);
	}

	checkFile(file, form) {
		var _this = this;
		if (file && file.name.endsWith('.epw')) {
			var reader = new FileReader();
			reader.onload = function(e) {
				var fileContent = e.target.result;
				_this.checkEPWFileContent(fileContent, (response) => {
					if (response.success) {
						document.querySelector('.section__get-started form input[name="location"]').value = response.data; 
						ajaxPH.maskOn(() => form.submit());
						_this.hideError();
					}
					else {
						_this.showError(response.data);
					}
				});
			};
			reader.readAsText(window.uploadedFile);
		}
		else
			_this.showError('File not supported.');
	}

	init() {
		this.events();
		var _this = this;
		var form = document.querySelector('.section__get-started form');

		window.selectedLocation = '';
		window.global.initSelect('main.home .section__get-started .custom-select-wrapper', (option) => {
			window.selectedLocation = jQuery(option).data('value');
			document.querySelector('.section__get-started form input[name="location"]').value = window.selectedLocation;
		});

		const uploadArea = document.getElementById('upload-area');
		const fileInput = document.getElementById('file-input');
		const browseButton = document.getElementById('browse-button');
	
		uploadArea.addEventListener('dragover', (event) => {
			event.preventDefault();
			uploadArea.classList.add('dragover');
		});
	
		uploadArea.addEventListener('dragleave', () => {
			uploadArea.classList.remove('dragover');
		});
	
		uploadArea.addEventListener('drop', (event) => {
			event.preventDefault();
			uploadArea.classList.remove('dragover');
			const file = event.dataTransfer.files[0];
			window.uploadedFile = file;
			this.checkFile(file, form)
		});
	
		browseButton.addEventListener('click', () => {
			fileInput.click();
		});
	
		fileInput.addEventListener('change', () => {
			const file = fileInput.files[0];
			window.uploadedFile = file;
			this.checkFile(file, form)
		});

		jQuery('body').on('click', '.next-button input', function(e) {
			e.preventDefault();
			e.stopPropagation();
			if (window.selectedLocation == '')
			{
				_this.showError('Please select a location.')
				return;
			}
			ajaxPH.maskOn(() => form.submit());
		})
	}

	destroy() {

	}
}
